import { render, staticRenderFns } from "./NeetDocente.vue?vue&type=template&id=5e6d3b62"
import script from "./NeetDocente.vue?vue&type=script&lang=js"
export * from "./NeetDocente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports